<template>
  <section id="pdf">
    <h1>Reporte de Apartados</h1>
    <div v-if="apartados.length > 0">
      <b-table class="box pdf-summary" :data="totalesGenerales">
        <b-table-column field="nombre" label="Resumen" v-slot="props">
          {{ props.row.nombre }}
        </b-table-column>
        <b-table-column field="total" label="Valor" v-slot="props">
          {{ props.row.total }}
        </b-table-column>
      </b-table>

      <b-table class="box" :data="apartadosFiltrados">
        <b-table-column field="nombre" label="Método de pago" v-slot="props">
          {{ props.row.nombre }}
        </b-table-column>
        <b-table-column field="total" label="Total pagado" v-slot="props">
          {{ props.row.total }}
        </b-table-column>
        <b-table-column field="cantidad" label="Cantidad cuentas" v-slot="props">
          {{ props.row.cantidad }}
        </b-table-column>
      </b-table>
      <b-table class="box" :data="apartadosFiltradosTotal">
        <b-table-column field="nombre" v-slot="props">
          {{ props.row.nombre }}
        </b-table-column>
        <b-table-column field="total" v-slot="props">
          ${{ props.row.total }}
        </b-table-column>
        <b-table-column field="cantidad" v-slot="props">
          {{ props.row.cantidad }}
        </b-table-column>
      </b-table>
      <br />
      <br />

      <b-table class="box" :data="apartados">
        <b-table-column field="fecha" label="Fecha" sortable searchable v-slot="props">
      {{ new Date(props.row.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', }).replace(/\//g, '-') }}
      </b-table-column>

        <b-table-column field="nombreCliente" label="Cliente" v-slot="props">
          {{ props.row.nombreCliente }}
        </b-table-column>

        <b-table-column field="nombreUsuario" label="Usuario" v-slot="props">
          {{ props.row.nombreUsuario }}
        </b-table-column>

        <b-table-column field="pagado" label="Pago" v-slot="props">
          <span class="has-text-info has-text-weight-bold">${{ props.row.pagado }}</span>
        </b-table-column>

        <b-table-column field="porPagar" label="Por pagar" v-slot="props">
          <span class="has-text-danger has-text-weight-bold"> ${{ props.row.porPagar }}</span>
        </b-table-column>

        <b-table-column field="total" label="Total" v-slot="props">
          <b>${{ props.row.total }}</b>
        </b-table-column>

        <b-table-column field="productos" label="Productos" v-slot="props">
          <tabla-productos-vendidos :productos="props.row.productos" />
        </b-table-column>

        <b-table-column field="estado" label="Estado" sortable searchable v-slot="props">
          <span class="tag is-success is-large" v-if="obtenerEstadoCuenta(props.row) === 'LIQUIDADO'">LIQUIDADO</span>
          <span class="tag is-warning is-large" v-if="obtenerEstadoCuenta(props.row) === 'VIGENTE'">VIGENTE</span>
          <span class="tag is-danger is-large" v-if="obtenerEstadoCuenta(props.row) === 'VENCIDA'">VENCIDA</span>
        </b-table-column>
      </b-table>
    </div>
    <div v-if="apartados.length < 1">
      <p>No existen apartados en el sistema.</p>
    </div>
  </section>
</template>

<script>
import Printd from 'printd'
import TablaProductosVendidos from '../Ventas/TablaProductosVendidos.vue';
import HttpService from '@/Servicios/HttpService';
import Utiles from '@/Servicios/Utiles';

export default {
  name: 'PDFApartados',
  components: { TablaProductosVendidos },

  data: () => ({
    apartados: [],
    apartadosFiltrados: [],
    apartadosFiltradosTotal: [],
    totalesGenerales: [],
    tasa: 0,
  }),

  methods: {
    formatoMonto (valor) {
      return Utiles.formatoMonto(valor)
    },

    async fetchSalesData() {
      const payload = {
        accion: 'obtener_apartados',
        filtros: {
          fechaInicio: this.$route.query.fechaInicio || null,
          fechaFin: this.$route.query.fechaFin || null,
          clienteId: this.$route.query.clienteId || null,
          pagina: null,
          limite: null,
        },
      };
      
      const resultado = await HttpService.obtenerConConsultas('ventas.php', payload);
      this.apartados = resultado.apartados || [];
      this.tasa = resultado.tasa?.valor ?? 0
      this.apartadosFiltrados = (resultado.apartadosFiltrados || []).map(apartado => ({
        nombre: apartado.metodo_pago,
        total: `${this.formatoMonto(apartado.total)}`,
        totalBs: `${this.formatoMonto(apartado.totalBs)}`,
        icono: 'credit-card-outline',
        clase: 'has-text-info',
        cantidad: apartado.cuentas_apartados_totales,
      }))
      this.apartadosFiltradosTotal = [{
        nombre: 'Total',
        total: (resultado.apartadosFiltrados || []).reduce((acc, item) => acc + Number(item.total || 0), 0),
        cantidad: (resultado.apartadosFiltrados || []).reduce((acc, item) => acc + Number(item.cuentas_apartados_totales || 0), 0),
      }]
      this.totalesGenerales = [
        { nombre: '# Apartados', total: resultado.total || 0, icono: 'wallet-travel', clase: 'has-text-primary' },
        { nombre: 'Total ', total: '$' + this.formatoMonto(resultado.totalApartados || 0), icono: 'cash-fast', clase: 'has-text-success' },
        { nombre: 'Por pagar Dólares', total: '$' + this.formatoMonto(resultado.totalPorPagar || 0), icono: 'alert', clase: 'has-text-danger' },
        { nombre: 'Por pagar Bolívares', total: 'Bs. ' + this.formatoMonto((resultado.totalPorPagar || 0) * this.tasa), icono: 'alert', clase: 'has-text-danger' },
        { nombre: 'Pagos', total: '$' + this.formatoMonto(resultado.totalPagos || 0), icono: 'account-cash', clase: 'has-text-grey-light' },
        { nombre: '# Productos', total: resultado.totalProductosVendidos || 0, icono: 'package-variant', clase: 'has-text-warning' },
      ]
    },
    
    printDocument() {
      return new Promise(resolve => {
        setTimeout(() => {
          const d = new Printd();
          const table = document.querySelector('#pdf');
          
          d.onAfterPrint(() => {
            window.close();
            resolve();
          });
          
          d.print(table, ['/pdf.css']);
        }, 100);
      });
    },

    obtenerEstadoCuenta(cuenta) {
      if (cuenta.porPagar < 1) return 'LIQUIDADO';
      const fechaCreacion = new Date(cuenta.fecha.replace(' ', 'T'));
      const fechaVencimiento = new Date(fechaCreacion);
      fechaVencimiento.setDate(fechaVencimiento.getDate() + Number(cuenta.dias || 0));
      const hoy = new Date();
      hoy.setHours(0, 0, 0, 0);
      if (hoy > fechaVencimiento) return 'VENCIDA';
      return 'VIGENTE';
    }
  },

  async mounted() {
    document.body.style.opacity = '0';
    
    await this.fetchSalesData();
    await this.printDocument();
  },
}
</script>
